import Holding from "./Holding";
import { TransactionType } from "../shared/Consts";

export default class CashHolding extends Holding {
    override get payout() {return 0}
    override get yield(){ return 0}
    get totalDeposits(){
        return this.transactions.reduce((p, t) => {
            if (t.isBuyOrSell) return p + t.quantity
            else return p
        }, 0)
    }
    override computePayout() {
        // computed in updatedTransactions
        return this;      
    }
    override updateTransactions(){
        return this;
    }
    override computePerformance(){
        this.currentPrice = this.averagePrice = 1;
        let qty = 0;
        let cost = 0;
        for(let trans of this.transactions){
            this.cumulateSum(trans);
            qty += trans.quantity
            if (trans.isBuyOrSell || trans.isAdjust) cost += trans.quantity*trans.price
            if (trans.type==TransactionType.dividend || trans.type==TransactionType.interest) this.dividend += trans.quantity*trans.price;
        }
        this.holdingValue = this.quantity = qty;
        this.originalCost = this.holdingCost = cost;
        this.gain = this.dividend;
        const totalCost = this.totalDeposits
        this.mwPercent = totalCost ? this.dividend / totalCost * 100 : 0;
        this.holdingPercent = this.holdingCost ? (this.holdingValue-this.holdingCost)/this.holdingCost * 100 : 0;
        this.a_payout = 0;
        this.excessDiv = 0;
        return this
    }
}